import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyCmPZ_SjYn7dpEmqh__XwbltVOgbd49gLI",
  authDomain: "videoshare-244c4.firebaseapp.com",
  projectId: "videoshare-244c4",
  storageBucket: "videoshare-244c4.firebasestorage.app",
  messagingSenderId: "139094619821",
  appId: "1:139094619821:web:63e03db75974bd5f3bb824",
  measurementId: "G-ZH2L96BGJ4"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const provider = new GoogleAuthProvider();

export { auth, provider };
